import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';
import { Reservation } from '../../reservation.model';

export class FrontDeskArrivalReport extends AbstractReport {

    static get STATUS_IN_HOUSE() {

        return Reservation.STATUS_IN_HOUSE.key;
    }
}

AccessorsMutatorsDecorator(
    'ident',
    'guest_name',
    'check_in',
    'check_out',
    'estimated_arrival_time',
    'room_type',
    'reservation_id',
    'guest_id',
    'number_of_nights',
    'guest_count',
    'checked_in',
    'rooms',
)(FrontDeskArrivalReport);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/front-desk/arrival-report.model.js